import React, { createContext, useContext, useState } from 'react';
import { NotAvailableDialog } from '@/components/NotAvailableDialog';

const NotAvailableContext = createContext({});

export const NotAvailableProvider = ({ onPopupClose = () => {}, children }) => {
  const [open, _setOpen] = useState(false);

  const setOpen = () => {
    _setOpen(true);
  };

  return (
    <NotAvailableContext.Provider value={{ showPopup: setOpen }}>
      {open && <NotAvailableDialog onClick={onPopupClose} />}
      {children}
    </NotAvailableContext.Provider>
  );
};

export const useShowNotAvailable = () => {
  return useContext(NotAvailableContext);
};
